export var ModuleSyncType;
(function (ModuleSyncType) {
    ModuleSyncType[ModuleSyncType["NoSync"] = 0] = "NoSync";
    ModuleSyncType[ModuleSyncType["CSVSync"] = 1] = "CSVSync";
    ModuleSyncType[ModuleSyncType["APISync"] = 2] = "APISync";
})(ModuleSyncType || (ModuleSyncType = {}));
//# sourceMappingURL=types.js.map